export const PACKAGE_PERMISSIONS = {
  DISCOUNT: 'discounts',
  CAMPAIGN: 'campaigns',
  COUPON: 'coupons',
  MARKETING_EVENT: 'marketing-events',
  FEEDBACK: 'surveys',
  KITCHEN: 'order_display_sys',
  QR_CUSTOMIZATION: 'qr_theme',
  IPAD: 'ipad_theme',
  RESERVATION: 'reservation',
  STATISTICS: 'statistics',
  NEWSLETTER: 'newsletter',
  QUEUE: 'queue',
  CRM: 'crm',
  INVENTORY: 'inventory',
  WALLET_PACKAGES: 'wallet_packages',
  PROMOTIONS: 'promotions',
  PRODUCT_RESERVATION: 'product_reservation',
  PRODUCT_OPTIONS_VARIANTS: 'product_options_variants',
  CUSTOM_INPUTS: 'custom-inputs',
}

export const ADDON_SLUGS = {
  TABLE_RESERVATION: 'table_reservation',
  SIZE_GUIDE: 'size_guide',
  DASHBOARD_API: 'dashboard_api',
  INVENTORY: 'inventory',
  EXTRA_BRANCHES: 'extra_branches',
}

const FEATURES = {
  BRANCHES: 'branch',
  CLOUD: 'cloud',
  DEVICE: 'device',
  SUB_USERS: 'subusers',
  QR_ITEMS: 'qr_items',
  LANGUAGE: 'language',
  GOOGLE: 'google',
}

export const PACKAGE_FEATURES = {
  INVENTORY: 'inventory',
}
export default FEATURES
